import React from 'react';
import PropTypes from 'prop-types';
import RichText from 'components/rich-text';
import ImageBlock from 'components/image-block';
import cn from 'classnames';

const RichTextBlock = ({ sideImage, textHtml }) => {
  return (
    <div
      className={cn('rich-text-block', {
        'rich-text-block_with-image': sideImage,
      })}
    >
      <div className="rich-text-block__container">
        <div className="rich-text-block__wrapper">
          <RichText
            text={textHtml}
            className="rich-text-block__content rich-text_in-rich-text-block"
          />
          {sideImage && (
            <ImageBlock
              {...sideImage}
              className="rich-text-block__image image-block_local"
              imageClassName="image_size_rich-text-block"
            />
          )}
        </div>
      </div>
    </div>
  );
};

RichTextBlock.propTypes = {
  sideImage: PropTypes.exact(ImageBlock.propTypes),
  textHtml: PropTypes.string,
};

export default RichTextBlock;
